module.exports = __webpack_public_path__ + "img/aodesign.8910067c.png";